module.exports = __webpack_public_path__ + "static/media/IAQAnalytics2.90485a5f.png";